module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-09-09 at 3.21.50 PM.36c47a0c.png";